module.exports = __webpack_public_path__ + "img/hamburger.fa70fd68.svg";